 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"accountSearch~bindnewacct~bindoldacct~checkacct~dividendInfo~etflist~frame~infoCollection~login~modi~80effddb":"accountSearch~bindnewacct~bindoldacct~checkacct~dividendInfo~etflist~frame~infoCollection~login~modi~80effddb","accountSearch":"accountSearch","activebank~addbank~bindnewacct~bindoldacct~changebank~checkacct~modifybank~resetlogin~signbank~trade~49136e51":"activebank~addbank~bindnewacct~bindoldacct~changebank~checkacct~modifybank~resetlogin~signbank~trade~49136e51","bindnewacct~bindoldacct":"bindnewacct~bindoldacct","bindnewacct":"bindnewacct","bindoldacct":"bindoldacct","checkacct~modifyinfo":"checkacct~modifyinfo","checkacct~infoCollection":"checkacct~infoCollection","checkacct":"checkacct","buyfund~changefund~currencycharge~currencyplan~generalbuy~generalchange~generalrecovery~orderbuyfund~6c653d46":"buyfund~changefund~currencycharge~currencyplan~generalbuy~generalchange~generalrecovery~orderbuyfund~6c653d46","orderbuyfund":"orderbuyfund","ordersell":"ordersell","infoCollection":"infoCollection","modifyinfo":"modifyinfo","dividendInfo":"dividendInfo","etflist":"etflist","frame~login~outframe":"frame~login~outframe","currencyfund~login~register":"currencyfund~login~register","login":"login","frame":"frame","outframe":"outframe","plandeduction":"plandeduction","plandetail":"plandetail","profitqry":"profitqry","remitinfo":"remitinfo","statement":"statement","traderecord":"traderecord","activebank":"activebank","addbank":"addbank","changebank":"changebank","modifybank":"modifybank","resetlogin~tradepwd":"resetlogin~tradepwd","resetlogin":"resetlogin","tradepwd":"tradepwd","signbank":"signbank","unsignbank":"unsignbank","bank":"bank","bindacctway":"bindacctway","bindmobile":"bindmobile","buyfund":"buyfund","changefund":"changefund","currencycharge":"currencycharge","currencyplan~generalbuy~generalchange~generalrecovery~wisdombuy":"currencyplan~generalbuy~generalchange~generalrecovery~wisdombuy","currencyplan":"currencyplan","generalbuy":"generalbuy","generalchange":"generalchange","generalrecovery":"generalrecovery","wisdombuy":"wisdombuy","privatebuy":"privatebuy","sellfund":"sellfund","cfund":"cfund","changelpwd":"changelpwd","changeqpwd":"changeqpwd","changetpwd":"changetpwd","combofund":"combofund","combogeneral":"combogeneral","currencyfund~home~mycurrency":"currencyfund~home~mycurrency","currencyfund":"currencyfund","home":"home","mycurrency":"mycurrency","register":"register","currencyredemption":"currencyredemption","err":"err","fund":"fund","fundmarket":"fundmarket","generalfund":"generalfund","hotfund~privatehot":"hotfund~privatehot","hotfund":"hotfund","privatehot":"privatehot","info":"info","infoPublish":"infoPublish","invchange":"invchange","knowdetail":"knowdetail","myorder":"myorder","myplan":"myplan","ocrinfoupd":"ocrinfoupd","optionalfund":"optionalfund","optionalgeneral":"optionalgeneral","orderfund":"orderfund","policyAndLaw":"policyAndLaw","privateassets":"privateassets","privatefund":"privatefund","privateupload":"privateupload","resetpwdway":"resetpwdway","risk":"risk","risktest":"risktest","securitycenter":"securitycenter","service":"service","taxes":"taxes","wxbind":"wxbind","wxbindchange":"wxbindchange"}[chunkId]||chunkId) + "." + {"accountSearch~bindnewacct~bindoldacct~checkacct~dividendInfo~etflist~frame~infoCollection~login~modi~80effddb":"3c24210e","accountSearch":"0578b5be","activebank~addbank~bindnewacct~bindoldacct~changebank~checkacct~modifybank~resetlogin~signbank~trade~49136e51":"1995f993","bindnewacct~bindoldacct":"d43b00c0","bindnewacct":"c77dc679","bindoldacct":"ed60afed","checkacct~modifyinfo":"641b55e4","checkacct~infoCollection":"6886e2e6","checkacct":"1121bca3","buyfund~changefund~currencycharge~currencyplan~generalbuy~generalchange~generalrecovery~orderbuyfund~6c653d46":"ffbdfbb7","orderbuyfund":"32fdbe80","ordersell":"68dc8681","infoCollection":"e787df5d","modifyinfo":"a815c2d2","dividendInfo":"9fa4cf98","etflist":"b5e234ae","frame~login~outframe":"7beb9eef","currencyfund~login~register":"634d8f95","login":"0f7f7739","frame":"38478289","outframe":"15b088de","plandeduction":"2cbfa9a9","plandetail":"4bc00196","profitqry":"e5e96693","remitinfo":"d2f9bcaa","statement":"600cc006","traderecord":"de4bac4a","activebank":"77927bfe","addbank":"9a26dcab","changebank":"b95e07c0","modifybank":"508cfbc5","resetlogin~tradepwd":"cc51dcc7","resetlogin":"4e52bf6f","tradepwd":"79ea58ff","signbank":"7ff7114d","unsignbank":"cceae460","bank":"76094233","bindacctway":"e8087c4c","bindmobile":"3a62f74e","buyfund":"cadbf2fb","changefund":"5bb5bb56","currencycharge":"497ef9ae","currencyplan~generalbuy~generalchange~generalrecovery~wisdombuy":"f8d09bf0","currencyplan":"1ea783ae","generalbuy":"2a93a5b2","generalchange":"c3a5f98a","generalrecovery":"a3851c13","wisdombuy":"82fb4270","privatebuy":"8089ec5b","sellfund":"0828993c","cfund":"94f61076","changelpwd":"ca074f1b","changeqpwd":"fe471cf7","changetpwd":"16145460","combofund":"f1f402ae","combogeneral":"f7e0c225","currencyfund~home~mycurrency":"da2b3d91","currencyfund":"a2630953","home":"cf158799","mycurrency":"3015a025","register":"bd58a754","currencyredemption":"0550633f","err":"9c405373","fund":"d487b35e","fundmarket":"0dd462ba","generalfund":"6dd7b925","hotfund~privatehot":"7af697c6","hotfund":"c60534fb","privatehot":"f04b87f0","info":"312ed8ae","infoPublish":"eb744401","invchange":"87ed4625","knowdetail":"5fed6200","myorder":"98a61d83","myplan":"cf1e098f","ocrinfoupd":"42304ab5","optionalfund":"95f9f626","optionalgeneral":"8ad5f97e","orderfund":"bec87fcf","policyAndLaw":"3df7ac13","privateassets":"5fa553d8","privatefund":"a3180df7","privateupload":"51f7a911","resetpwdway":"10a90025","risk":"fe30074a","risktest":"22ce6be6","securitycenter":"36bf8ba5","service":"32766eea","taxes":"fdc8da34","wxbind":"2274601a","wxbindchange":"5ab0ed1e","chunk-5c08f684":"b76007e6","chunk-9a563a56":"cde332b2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"accountSearch":1,"activebank~addbank~bindnewacct~bindoldacct~changebank~checkacct~modifybank~resetlogin~signbank~trade~49136e51":1,"bindnewacct~bindoldacct":1,"bindnewacct":1,"bindoldacct":1,"checkacct~modifyinfo":1,"checkacct~infoCollection":1,"checkacct":1,"buyfund~changefund~currencycharge~currencyplan~generalbuy~generalchange~generalrecovery~orderbuyfund~6c653d46":1,"orderbuyfund":1,"ordersell":1,"infoCollection":1,"modifyinfo":1,"dividendInfo":1,"etflist":1,"frame~login~outframe":1,"login":1,"frame":1,"plandeduction":1,"plandetail":1,"profitqry":1,"remitinfo":1,"statement":1,"traderecord":1,"activebank":1,"addbank":1,"changebank":1,"modifybank":1,"resetlogin~tradepwd":1,"resetlogin":1,"tradepwd":1,"signbank":1,"unsignbank":1,"bank":1,"bindacctway":1,"bindmobile":1,"buyfund":1,"changefund":1,"currencycharge":1,"currencyplan~generalbuy~generalchange~generalrecovery~wisdombuy":1,"currencyplan":1,"generalbuy":1,"generalchange":1,"generalrecovery":1,"wisdombuy":1,"privatebuy":1,"sellfund":1,"cfund":1,"changelpwd":1,"changeqpwd":1,"changetpwd":1,"combofund":1,"combogeneral":1,"currencyfund~home~mycurrency":1,"currencyfund":1,"home":1,"mycurrency":1,"register":1,"currencyredemption":1,"err":1,"fundmarket":1,"generalfund":1,"hotfund~privatehot":1,"hotfund":1,"privatehot":1,"info":1,"infoPublish":1,"invchange":1,"knowdetail":1,"myorder":1,"myplan":1,"ocrinfoupd":1,"optionalfund":1,"optionalgeneral":1,"orderfund":1,"policyAndLaw":1,"privateassets":1,"privatefund":1,"privateupload":1,"resetpwdway":1,"risk":1,"risktest":1,"securitycenter":1,"service":1,"taxes":1,"wxbind":1,"wxbindchange":1,"chunk-5c08f684":1,"chunk-9a563a56":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"accountSearch~bindnewacct~bindoldacct~checkacct~dividendInfo~etflist~frame~infoCollection~login~modi~80effddb":"accountSearch~bindnewacct~bindoldacct~checkacct~dividendInfo~etflist~frame~infoCollection~login~modi~80effddb","accountSearch":"accountSearch","activebank~addbank~bindnewacct~bindoldacct~changebank~checkacct~modifybank~resetlogin~signbank~trade~49136e51":"activebank~addbank~bindnewacct~bindoldacct~changebank~checkacct~modifybank~resetlogin~signbank~trade~49136e51","bindnewacct~bindoldacct":"bindnewacct~bindoldacct","bindnewacct":"bindnewacct","bindoldacct":"bindoldacct","checkacct~modifyinfo":"checkacct~modifyinfo","checkacct~infoCollection":"checkacct~infoCollection","checkacct":"checkacct","buyfund~changefund~currencycharge~currencyplan~generalbuy~generalchange~generalrecovery~orderbuyfund~6c653d46":"buyfund~changefund~currencycharge~currencyplan~generalbuy~generalchange~generalrecovery~orderbuyfund~6c653d46","orderbuyfund":"orderbuyfund","ordersell":"ordersell","infoCollection":"infoCollection","modifyinfo":"modifyinfo","dividendInfo":"dividendInfo","etflist":"etflist","frame~login~outframe":"frame~login~outframe","currencyfund~login~register":"currencyfund~login~register","login":"login","frame":"frame","outframe":"outframe","plandeduction":"plandeduction","plandetail":"plandetail","profitqry":"profitqry","remitinfo":"remitinfo","statement":"statement","traderecord":"traderecord","activebank":"activebank","addbank":"addbank","changebank":"changebank","modifybank":"modifybank","resetlogin~tradepwd":"resetlogin~tradepwd","resetlogin":"resetlogin","tradepwd":"tradepwd","signbank":"signbank","unsignbank":"unsignbank","bank":"bank","bindacctway":"bindacctway","bindmobile":"bindmobile","buyfund":"buyfund","changefund":"changefund","currencycharge":"currencycharge","currencyplan~generalbuy~generalchange~generalrecovery~wisdombuy":"currencyplan~generalbuy~generalchange~generalrecovery~wisdombuy","currencyplan":"currencyplan","generalbuy":"generalbuy","generalchange":"generalchange","generalrecovery":"generalrecovery","wisdombuy":"wisdombuy","privatebuy":"privatebuy","sellfund":"sellfund","cfund":"cfund","changelpwd":"changelpwd","changeqpwd":"changeqpwd","changetpwd":"changetpwd","combofund":"combofund","combogeneral":"combogeneral","currencyfund~home~mycurrency":"currencyfund~home~mycurrency","currencyfund":"currencyfund","home":"home","mycurrency":"mycurrency","register":"register","currencyredemption":"currencyredemption","err":"err","fund":"fund","fundmarket":"fundmarket","generalfund":"generalfund","hotfund~privatehot":"hotfund~privatehot","hotfund":"hotfund","privatehot":"privatehot","info":"info","infoPublish":"infoPublish","invchange":"invchange","knowdetail":"knowdetail","myorder":"myorder","myplan":"myplan","ocrinfoupd":"ocrinfoupd","optionalfund":"optionalfund","optionalgeneral":"optionalgeneral","orderfund":"orderfund","policyAndLaw":"policyAndLaw","privateassets":"privateassets","privatefund":"privatefund","privateupload":"privateupload","resetpwdway":"resetpwdway","risk":"risk","risktest":"risktest","securitycenter":"securitycenter","service":"service","taxes":"taxes","wxbind":"wxbind","wxbindchange":"wxbindchange"}[chunkId]||chunkId) + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/agate/jfit/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
